// extracted by mini-css-extract-plugin
export default {"ui_kit_checkbox":"checkbox_ui_kit_checkbox__gEK6I","ui_kit_checkbox_box":"checkbox_ui_kit_checkbox_box__S4FXU","ui_kit_checkbox_title":"checkbox_ui_kit_checkbox_title__20Z+l"};